module.exports = __webpack_public_path__ + "static/media/christian-1.def6673b.jpg";